import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  GridFooterContainer,
  GridPagination,
  gridVisibleColumnDefinitionsSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { formatToUSD } from 'utils/participation';

export interface AssessmentPaymentFooterProps {
  totalAmount: string;
}

export const AssessmentPaymentFooter = React.forwardRef<HTMLDivElement, AssessmentPaymentFooterProps>(function AssessmentPaymentFooter(
  { totalAmount, ...other },
  ref,
) {
  const apiRef = useGridApiContext();
  const columns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);

  return (
    <GridFooterContainer
      ref={ref}
      {...other}
      sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
        minHeight: 'auto',
        borderTop: theme => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box display="flex" width="100%" alignItems="center" py={2}>
        {columns.map(column => {
          const width = column.computedWidth;
          let content: React.ReactNode = null;

          if (column.field === 'balance') {
            content = (
              <Typography fontSize={16} fontWeight="bold" textAlign="right" width="100%" color="primary.main">
                Total Amount:
              </Typography>
            );
          } else if (column.field === 'amount') {
            content = (
              <Typography fontSize={16} fontWeight="bold" textAlign="right" width="100%" color="primary.main">
                {formatToUSD(Number(totalAmount))}
              </Typography>
            );
          }

          return (
            <Box
              key={column.field}
              sx={{
                width,
                minWidth: width,
                maxWidth: width,
                boxSizing: 'border-box',
                px: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: column.align === 'right' ? 'flex-end' : 'flex-start',
              }}
            >
              {content}
            </Box>
          );
        })}
      </Box>
      <Box display="flex" justifyContent="flex-end" width="100%">
        <GridPagination />
      </Box>
    </GridFooterContainer>
  );
});
